import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/_services/app.service';

@Component({
    selector: 'app-dialog-status',
    templateUrl: './dialog-status.component.html',
    styleUrls: ['./dialog-status.component.css'],
    standalone: false
})
export class DialogStatusComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
  }

}
